import Group from '@/types/Group.interface'
import Vue from 'vue'
import moment from 'moment-timezone'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    methods: {
        goToBroadcastCreate(group: Group): void {
            //  Report to analytics
            Analytics.track('GroupSendBroadcastClicked')

            //  Navigate to broadcast create
            this.$router.push(`/broadcasts/create?group=${group.id}`)
        },
        goToGroupEdit(group: Group): void {
            //  Navigate to group edit
            this.$router.push(`/groups/${group.id}/edit`)
        },
        async groupCopy(group: Group, callback: Function): Promise<void> {
            //  Get the group members count
            const members = group.persons_count

            //  If the group has no members, pop 'No Contacts'
            if (!members) return this.popNoPersons()

            //  Else, if the group has more than 200 members, pop 'Group Too Large'
            // if (members > 200) return this.popGroupTooLarge()

            //  Else, create a formatted date, to use in our snapshot description
            const date = moment().format('MM/DD/YYYY h:mm:ss')

            //  Create a request payload by cloning of the selected group
            const payload = { ...group }

            //  Attach 'snapshot' properties to the payload
            payload.name = `Duplicate: ${date}`
            payload.description = `A duplicate group of ${group.name} created on ${date}.`
            payload.snapshot = true

            //  Post the snapshot to the API
            const response = await this.$store.dispatch('groupsPost', payload)

            //  If the request failed, do nothing
            if (!response) return

            //  Else, route the user to the new group
            this.$router.push(`/groups/${response.id}`)

            //  Notify the user of successful snapshot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Duplicate Created',
                text: 'Your duplicate group has been successfully created.',
                icon: 'mdi-check',
                color: 'primary'
            })

            //  If a callback exists, use it!
            if (callback) callback(response)
        },
        async groupDelete(group: Group, callback: Function): Promise<void> {
            //  Confirm the user wants to delete the group
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Group?',
                text: 'Are you sure you want to delete this group? This will also delete any autoresponders attached to this group.',
                icon: 'bi-trash-fill',
                color: 'red darken-2',
                callback: async (result: boolean): Promise<void> => {
                    //  If the user answered 'NO' in the confirm dialog, do nothing
                    if (!result) return

                    //  Else, send the delete request to the API
                    const response = await this.$store.dispatch('groupsDelete', group)

                    //  If the request failed, do nothing
                    if (!response) return

                    //  Else, notify the user of successful delete
                    this.$store.commit('appNotificationBarSet', {
                        message: 'Group Deleted'
                    })

                    //  If a callback exists, use it!
                    if (callback) callback(response)
                }
            })
        },
        async groupExport(group: Group): Promise<void> {
            //  Send export request to the API
            const response = await this.$store.dispatch('groupsCsvExport', group.id)

            //  If the request failed, do nothing
            if (!response) return

            //  Else, notify user of export
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Export in Progress',
                icon: 'mdi-database-export',
                text: response.message
            })
        }
    }
})